import { inject, Injectable } from '@angular/core'
import { Action, select, Store } from '@ngrx/store'
import { GbBaseFacade } from 'libs/shared/data-access-core/src/lib/+state/gb-base-facade-interface'
import * as RafflesSelectors from './raffles.selectors'

@Injectable({ providedIn: 'root' })
export class RafflesFacade implements GbBaseFacade {
  private readonly store = inject(Store)

  loaded$ = this.store.pipe(select(RafflesSelectors.selectRafflesLoaded))
  allRaffleItems$ = this.store.pipe(select(RafflesSelectors.selectAllRaffles))
  selectedItem$ = this.store.pipe(select(RafflesSelectors.selectEntity))
  count$ = this.store.pipe(select(RafflesSelectors.selectCount))

  dispatch(action: Action): void {
    this.store.dispatch(action)
  }
}
